
import {
    SET_ISKN_DATE_NEW,
    SET_ISKN_DATE_OLD,
    SET_OPSUB_ITEM_NEW,
    SET_OPSUB_ITEM_OLD
} from '../../sagas/analyze2opsub';

import {
    GET_PROJECT_ACTION_TYPE
} from '../../sagas/project';

const initialState = {
    isknDateNew: null,
    isknDateOld: null,
    opsubItemNew: null,
    opsubItemOld: null
};

export function getIsknDateNew(state) {
    return state.isknDateNew;
}

export function getIsknDateOld(state) {
    return state.isknDateOld;
}

export function getOpsubItemNew(state) {
    return state.opsubItemNew;
}

export function getOpsubItemOld(state) {
    return state.opsubItemOld;
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_PROJECT_ACTION_TYPE.SUCCESS:
            return {
                ...initialState
            };

        case SET_ISKN_DATE_NEW:
            return {
                ...state,
                isknDateNew: action.isknDate
            };

        case SET_ISKN_DATE_OLD:
            return {
                ...state,
                isknDateOld: action.isknDate
            };

        case SET_OPSUB_ITEM_NEW:
            return {
                ...state,
                opsubItemNew: action.opsubItem
            };

        case SET_OPSUB_ITEM_OLD:
            return {
                ...state,
                opsubItemOld: action.opsubItem
            };

        default:
            return state;
    }
}
